<div class="fullwidth locateForm">
  <app-responsive-list-view
       [tableColumns]="_tableColumns"
       [sortingDataAccessor]="_sortingDataAccessor"
       [filteringPredicate]="_filteringPredicate"
       [service]="surveyService"
       [withAdd]="false"
       [hasListAccess]="hasListAccess"
       [maxCellStringLength]="80"
       [maxStringLength]="20"
       [inputFilterEventSubject]="filterEventSubject.asObservable()"
       (mode)="updateViewMode($event)"
       [booleanIconColumnDisplayList]="_booleanIconColumnDisplayList"
       tableTitleLabel="{{'siren-survey-translation.survey-response-table.title' | translate}}"
       [withInlineMenu]="false"
       [showFilterButton]="true"
       initialPageSize="10">
       <app-table-filter filter-content [filters]="filters" (filterOutput)="applyFilter($event)" [showFilterButton]="false"></app-table-filter>
       <app-table-filter filter-content-mobile [filters]="filters" (filterOutput)="applyFilter($event)" [showFilterButton]="false"></app-table-filter>
   </app-responsive-list-view>
 </div>
